export default __webpack_public_path__ + "static/TCBY-4c01c396f03ba517cf481f1d0b6c2300.png";